import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/context/ThemeContext';

export default function ThemeToggle({ variant = 'default' }) {
    const { theme, toggle } = useTheme();
    const isDark = theme === 'dark';

    const base = 'inline-flex items-center justify-center gap-2 px-3 py-2 text-xs font-semibold transition-colors';
    const styles = variant === 'onDark'
        ? 'border border-white/40 text-white hover:bg-white/10'
        : 'border border-gray-300 text-[#0A0A0A] hover:bg-gray-100 dark:border-gray-700 dark:text-white dark:hover:bg-white/10';

    return (
        <button
            onClick={toggle}
            data-testid="theme-toggle"
            aria-label={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
            className={`${base} ${styles}`}
        >
            {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            <span className="hidden sm:inline uppercase tracking-wider">{isDark ? 'Claro' : 'Oscuro'}</span>
        </button>
    );
}
